module.exports = __webpack_public_path__ + "static/media/house-7.80c016ba.jpg";